const initialState = {
	review: null,
	requested: null,
	history: {
		mine: null,
		org: null
	}
};

const changeRequests = (state = initialState, action) => {
	switch (action.type) {
		case "HYDRATE_CHANGE_REQUESTS_SUCCESS":
			return {
				...state,
				review: action.review,
				requested: action.requested
			};

		case "HYDRATE_CHANGE_REQUEST_HISTORY_SUCCESS":
			return {
				...state,
				history: {
					...state.history,
					[action.scope]: action.history
				}
			};
		default:
			return state;
	}
};

export default changeRequests;
